import { breakpoints, css } from '../../styles/theme';
import { rem } from 'polished';

export const StylesOV = css`
    .left,
    .right {
        background: ${({ theme }) => theme.colors.grey21};
    }
    .center {
        text-align: center;
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        text-transform: uppercase;
        font-size: ${({ theme }) => theme.fontSizes.h3};
    }
`;
